"use strict";
var emailMessages = {};
export default {
  updateEmailMessages: function(updatedEmailMessages) {
    return _.map(updatedEmailMessages, function(emailMessage) {
      var existing = emailMessages[String(emailMessage.id)];
      if (existing) {
        return _.extend(existing, emailMessage);
      } else {
        return emailMessages[String(emailMessage.id)] = emailMessage;
      }
    });
  },
  emailMessageWithId: function(id) {
    return emailMessages[String(id)] || null;
  }
};
